import { IAnalyticsEvent, IAnalyticsTrackingEvent } from './../interfaces/analytics.interface';

export const AnalyticsEventsMap = {
  getValue: (key: { value: string }) => key.value,
  getParams: (key: { params: IAnalyticsEvent }) => key.params,

  HOME: {
    INDEX: {
      value: 'home',
      params: {
        contentGrouping: 'home:ambiente-opb',
        eventCategory: 'opb-home:box',
        eventAction: 'clicou',
        eventLabel: 'open-banking',
      } as IAnalyticsEvent,
    },
    ACESSAR_TODOS: {
      value: 'acessar-todos',
      params: {
        contentGrouping: 'opb:ambiente-opb',
        eventCategory: 'opb-ambiente:acessar-todos:botao',
        eventAction: 'clicou',
        eventLabel: 'compartilhamentos-acessar-todos',
      } as IAnalyticsEvent,
    },
    CATEGORIA_DADOS: {
      value: 'confira-categoria-dados',
      params: {
        contentGrouping: 'opb:ambiente-opb',
        eventCategory: 'opb-ambiente:confira-categoria-dados:botao',
        eventAction: 'clicou',
        eventLabel: 'categoria-de-dados',
      } as IAnalyticsEvent,
    },
    PORTAL_CIDADAO: {
      value: 'portal-cidadao',
      params: {
        contentGrouping: 'opb:ambiente-opb',
        eventCategory: 'opb-ambiente:portal-cidadao:botao',
        eventAction: 'clicou',
        eventLabel: 'portal-cidadao',
      } as IAnalyticsEvent,
    },
    SAIBA_MAIS: {
      value: 'saiba-mais',
      params: {
        contentGrouping: 'opb:ambiente-opb',
        eventCategory: 'opb-ambiente:saiba-mais:botao',
        eventAction: 'clicou',
        eventLabel: 'o-que-e-o-open-banking',
      } as IAnalyticsEvent,
    },
    TERMOS_CONDICOES: {
      value: 'termos-condicoes',
      params: {
        contentGrouping: 'opb:ambiente-opb',
        eventCategory: 'opb-ambiente:termos-condicoes:botao',
        eventAction: 'clicou',
        eventLabel: 'termos-condicoes',
      } as IAnalyticsEvent,
    },
    TUTORIAL_OPEN_FINANCE: {
      value: 'tutorial-opb',
      params: {
        contentGrouping: 'opb:ambiente-opb',
        eventCategory: 'opb-ambiente:saiba-mais:botao',
        eventAction: 'clicou',
        eventLabel: 'tutorial-open-finance',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_ATIVO_ENCERRAR: {
      value: 'opb-compartilhamento-ativo-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-ativo-confirmacao',
        eventCategory: 'opb-compartilhamento-ativo-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-encerrar',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_ATIVO_ALTERAR: {
      value: 'opb-compartilhamento-ativo-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-ativo-confirmacao',
        eventCategory: 'opb-compartilhamento-ativo-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-alterar',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_ATIVO_RENOVAR: {
      value: 'opb-compartilhamento-ativo-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-ativo-confirmacao',
        eventCategory: 'opb-compartilhamento-ativo-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-renovar',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_VENCIDO_RENOVAR: {
      value: 'opb-compartilhamento-vencido-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-vencido-confirmacao',
        eventCategory: 'opb-compartilhamento-vencido-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-renovar',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_PENDENTE_ENCERRAR: {
      value: 'opb-compartilhamento-pendente-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-pendente-confirmacao',
        eventCategory: 'opb-compartilhamento-pendente-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-encerrar',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_PENDENTE_ALTERAR: {
      value: 'opb-compartilhamento-pendente-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-pendente-confirmacao',
        eventCategory: 'opb-compartilhamento-pendente-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-alterar',
      } as IAnalyticsEvent,
    },
    GESTAO_COMPARTILHAMENTO_CANCELADO_RENOVAR: {
      value: 'opb-compartilhamento-cancelado-confirmar',
      params: {
        contentGrouping: 'opb:gestao-compartilhamento-cancelado-confirmacao',
        eventCategory: 'opb-compartilhamento-cancelado-confirmar:lista',
        eventAction: 'selecionou',
        eventLabel: 'sim-renovar',
      } as IAnalyticsEvent,
    },
  },
  RECEPTORA: {
    SELECIONAR_FINALIDADE: {
      value: 'opb-selecao-finalidade',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-selecao-finalidade:lista',
        eventAction: 'clicou',
        eventLabel: 'selecao-finalidade',
      } as IAnalyticsEvent,
    },
    SELECIONAR_INSTITUICAO: {
      value: 'opb-selecao-instituicao',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-selecao-instituicao:lista',
        eventAction: 'clicou',
        eventLabel: 'selecao-instituicao',
      } as IAnalyticsEvent,
    },
    SELECIONAR_PRAZO: {
      value: 'opb-prazo',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-prazo:lista',
        eventAction: 'clicou',
        eventLabel: 'selecao-prazo',
      } as IAnalyticsEvent,
    },
    DADOS_CONTA: {
      value: 'opb-dados-de-conta',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-dados-de-conta:lista',
        eventAction: 'selecionou',
        eventLabel: 'dados-de-conta',
      } as IAnalyticsEvent,
    },
    DADOS_CARTAO: {
      value: 'opb-dados-de-cartao',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-dados-de-cartao:lista',
        eventAction: 'selecionou',
        eventLabel: 'dados-de-cartao',
      } as IAnalyticsEvent,
    },
    DADOS_CREDITO: {
      value: 'opb-dados-de-operacoes-credito',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-dados-de-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'contrato-de-credito',
      } as IAnalyticsEvent,
    },
    DADOS_CADASTRAIS: {
      value: 'opb-dados-cadastrais',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-dados-cadastrais:lista',
        eventAction: 'selecionou',
        eventLabel: 'dados-cadastrais',
      } as IAnalyticsEvent,
    },
    // SELECIONOU_CONTA_SALDO: {
    //   value: 'opb-dados-de-conta',
    //   params: {
    //     contentGrouping: 'opb:receptora:compartilhamento',
    //     eventCategory: 'opb-dados-de-conta:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'saldo',
    //   } as IAnalyticsEvent,
    // },
    // SELECIONOU_CONTA_LIMITES: {
    //   value: 'opb-dados-de-conta',
    //   params: {
    //     contentGrouping: 'opb:receptora:compartilhamento',
    //     eventCategory: 'opb-dados-de-conta:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'limites',
    //   } as IAnalyticsEvent,
    // },
    // SELECIONOU_CONTA_EXTRATO: {
    //   value: 'opb-dados-de-conta',
    //   params: {
    //     contentGrouping: 'opb:receptora:compartilhamento',
    //     eventCategory: 'opb-dados-de-conta:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'extrato',
    //   } as IAnalyticsEvent,
    // },
    // SELECIONOU_CARTAO_LIMITES: {
    //   value: 'opb-dados-de-cartao',
    //   params: {
    //     contentGrouping: 'opb:receptora:compartilhamento',
    //     eventCategory: 'opb-dados-de-cartao:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'limites',
    //   } as IAnalyticsEvent,
    // },
    // SELECIONOU_CARTAO_TRANSACOES: {
    //   value: 'opb-dados-de-cartao',
    //   params: {
    //     contentGrouping: 'opb:receptora:compartilhamento',
    //     eventCategory: 'opb-dados-de-cartao:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'transacoes',
    //   } as IAnalyticsEvent,
    // },
    // SELECIONOU_CARTAO_FATURAS: {
    //   value: 'opb-dados-de-cartao',
    //   params: {
    //     contentGrouping: 'opb-dados-de-cartao',
    //     eventCategory: 'opb-dados-de-cartao:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'faturas',
    //   } as IAnalyticsEvent,
    // },
    // SELECIONOU_CONTRATO: {
    //   value: 'opb-dados-de-operacoes-credito',
    //   params: {
    //     contentGrouping: 'opb:receptora:compartilhamento',
    //     eventCategory: 'opb-dados-de-operacoes-credito:lista',
    //     eventAction: 'selecionou',
    //     eventLabel: 'contrato-de-credito',
    //   } as IAnalyticsEvent,
    // },
    CONFIRMAR_COMPARTILHAMENTO: {
      value: 'opb-confirmar-compartilhamento',
      params: {
        contentGrouping: 'opb:receptora:compartilhamento',
        eventCategory: 'opb-confirmar-compartilhamento:lista',
        eventAction: 'clicou',
        eventLabel: 'confirmar-compartilhamento',
      } as IAnalyticsEvent,
    },
  },
  TRANSMISSORA: {
    SELECAO_CONTA: {
      value: 'opb-selecao-conta',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-selecao-conta:seletor',
        eventAction: 'clicou',
        eventLabel: 'selecionou-conta-pre',
      } as IAnalyticsEvent,
    },
    SELECAO_CARTAO: {
      value: 'opb-dados-de-cartao',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-dados-de-cartao:seletor',
        eventAction: 'clicou',
        eventLabel: 'selecionou-cartao-pos',
      } as IAnalyticsEvent,
    },
    CONFIRMAR_COMPARTILHAMENTO: {
      value: 'opb-confirmar-compartilhamento',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-confirmar-compartilhamento:lista',
        eventAction: 'clicou',
        eventLabel: 'confirmar-compartilhamento',
      } as IAnalyticsEvent,
    },
    SELECIONAR_TODOS: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'clicou',
        eventLabel: 'selecionar-todos',
      } as IAnalyticsEvent,
    },
    // CHEKS
    LOAN_CONSIGNADO: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'credito-pessoal-consignado',
      } as IAnalyticsEvent,
    },
    LOAN_CONTA_GARANTIDA: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'conta-garantida',
      } as IAnalyticsEvent,
    },
    LOAN_CAPITAL_GIRO: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'capital-de-giro',
      } as IAnalyticsEvent,
    },
    INVOICE_FINANCING_DESCONTO_DUPLICATA: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'desconto_duplicatas',
      } as IAnalyticsEvent,
    },
    INVOICE_FINANCING_ANTECIPACAO_RECEBIVEIS: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'antecipacao_recebiveis',
      } as IAnalyticsEvent,
    },
    LOAN_SEM_CONSIGNACAO: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'credito_pessoal_sem_consignado',
      } as IAnalyticsEvent,
    },
    LOAN_CHEQUE_ESPECIAL: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'cheque_especial',
      } as IAnalyticsEvent,
    },
    FINANCING_BENS_MOVEIS: {
      value: 'opb-operacoes-credito',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-operacoes-credito:lista',
        eventAction: 'selecionou',
        eventLabel: 'aquisicao_bens_moveis',
      } as IAnalyticsEvent,
    },

    // FIM CHEKS

    CANCELAR_COMPARTILHAMENTO: {
      value: 'opb-redirecionamento-receptora',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-redirecionamento-receptora:mensagem',
        eventAction: 'clicou',
        eventLabel: 'cancelar-compartilhamento',
      } as IAnalyticsEvent,
    },
    VOLTAR_TRANSMISSORA: {
      value: 'opb-redirecionamento-receptora',
      params: {
        contentGrouping: 'opb:transmissora:compartilhamento',
        eventCategory: 'opb-redirecionamento-receptora:mensagem',
        eventAction: 'clicou',
        eventLabel: 'voltar-transmissora',
      } as IAnalyticsEvent,
    },
  },
};

export const TagsEventMap = {
  RECEPTORA_SIMPLES: {
    RESUMO: {
      CONTINUAR: {
        event: 'event_openfinance_receptoraresumo_clicou_botao_continuar',
        page: 'opb:open-finance:receptora-resumo',
        eventCategory: 'opb:open-finance:receptora-resumo:body',
        eventAction: 'clicou',
        eventLabel: 'botao:continuar',
      } as IAnalyticsTrackingEvent,
      EXPANDIR_COMPARTILHAMENTO: {
        event: 'event_openfinance_receptoraresumo_clicou_botao_expandircompartilhamento',
        page: 'opb:open-finance:receptora-resumo',
        eventCategory: 'opb:open-finance:receptora-resumo:body',
        eventAction: 'clicou',
        eventLabel: 'botao:expandir-compartilhamento',
      } as IAnalyticsTrackingEvent,
      SELECIONAR_PERIODO: {
        event: 'event_openfinance_receptoraresumo_selecionou_prazo',
        page: 'opb:open-finance:receptora-resumo',
        eventCategory: 'opb:open-finance:receptora-resumo:body',
        eventAction: 'selecionou',
      } as IAnalyticsTrackingEvent,
      CLICOU_VOLTAR: {
        event: 'event_openfinance_receptoraresumo_clicou_botao_voltar',
        page: 'opb:open-finance:receptora-resumo',
        eventCategory: 'opb:open-finance:receptora-resumo:body',
        eventAction: 'clicou',
        eventLabel: 'botao:voltar',
      } as IAnalyticsTrackingEvent,
    },
  },
};
